const apiInfo = {
    'user': {
        'prefix': '/api',
        'group': '/User'
    },
    'roles': {
        'prefix': '/api'
    },
    'system': {
        'prefix': '/api',
        'group': '/System'
    },
    'masterData': {
        'prefix': '/api',
        'group': '/MasterData'
    },
    'mine': {
        'prefix': '/api',
        'group': '/Mine'
    },
    'planCenter': {
        'prefix': '/api',
        'group': '/PlanCenter'
    }
};

export default apiInfo;



// WEBPACK FOOTER //
// ./src/config/api.prod.js